import { layout_children } from "materials/layout/menus/index.js"
export default {
  name: "布局",
  id: "",
  type: "layoutComponent",
  children: layout_children
}
